ulekareApp.controller('subscriptionFormController', function ($scope, $window, $http, $interval, $timeout, C, T, SubscriptionFormStorage, AnalyticsLogger) {
	function checkErrors() {
		resetValidation();

		var fieldsCount = 0;

		var formFieldCount = $scope.formFieldsDefinition.length;
		// projdeme vsechny definice
		for (var i = 0; i < formFieldCount; i++) {
			fieldsCount++;
			var field = $scope.formFieldsDefinition[i];
			var fieldName = field.name;

			if (field.optional === true && (typeof $scope.formValues[fieldName] === 'undefined' || !$scope.formValues[fieldName])) {
				continue;
			}

			// jeste se na pole nesahlo
			if ($scope.formValues[fieldName] === undefined && $scope.formFieldsDefinition[i].required === true) {
				$scope.validation.missing.push(T.translateValidation(fieldName, 'missing'));
				$scope.validation.errorsCount++;
				continue;
			}

			// prvek se ma validovat - spustime kazdou validacni metodu
			if (field.validation) {
				for (var j = 0; j < field.validation.length; j++) {
					var params = field.validation[j];
					var fx = C.validationFunctions[params.type];
					var result = fx(params, $scope.formValues[fieldName]);
					if (result !== true) {
						if (field.required === true) {
							$scope.validation.missing.push(T.translateValidation(fieldName, 'missing'));
						}
						$scope.validation.errorsCount++;
						$scope.validation.errors[fieldName] = T.translateValidation(fieldName, params.type);
						break;
					}
				}
			}
		}

		// jeste se nezacal vyplnovat formular
		if ($scope.validation.errorsCount === fieldsCount) {
			$scope.validation.missing = [];
		}
	}

	function resetValidation() {
		$scope.validation = {
			'errors': {},
			'errorsCount': 0,
			'missing': []
		};
		$scope.showGeneralErrorAuthorizationMessage = false;
	}

	function resetData() {
		$scope.formValues = angular.extend({}, ulekareBackendVars.defaultFormValues, SubscriptionFormStorage.get());
		$scope.displayValues = {};
		$scope.status = {
			'step': 'new',
			'loading': false,
			'loadingMessage': T.translate('loadingMessage'),
			'waitingTimeExpired': false,
			'timeoutPopup': false,
			'lastChangedField': null,
		};
		$scope.paymentStatus = C.paymentStatus;
		$scope.changeInterval = null;
		$scope.generalErrorMessage = false;
		resetValidation();
	}

	function updateStyles() {
		UL.onJqueryLoad(function($) {
			$('#row-button, #row-done, #row-payment-status-wait, #row-error, #form-navigation, #loading-spinner').removeClass('hidden');
			$('#form-loading').addClass('hidden');
			$('#consultation-cover').toggleClass('hidden', $scope.status.step !== 'new' && $scope.status.step !== 'checkAuthorizationStatus');
			$('#row-tariff').toggleClass('hidden', true);
			$('#row-payment-method, #row-voucher').toggleClass('hidden', true);
			$('#consultation-partner-helpbar').toggleClass('hidden', $scope.status.step !== 'new' && $scope.status.step !== 'authorizationForm');

			$('#formEmail').on('input', function() {
				if ($(this)[0].checkValidity() === false) {
					$scope.validation.errors['email'] = T.translateValidation('email', 'email');
					$scope.validation.errorsCount++;
				}
			});
		});
	}

	function hasSubscriptionStatusDone(subscriptionData) {
		return subscriptionData.status && subscriptionData.status.id === C.status.subscription.done;
	}

	$scope.getFieldClass = function(fieldName) {
		if ($scope.validation.errors[fieldName]) {
			return 'is-error';
		} else if (fieldName === 'name' && ($scope.validation.errors['firstName'] || $scope.validation.errors['lastName'])) {
			return 'is-error';
		} else if (fieldName === 'voucher' && $scope.validation.voucherError) {
			return 'is-error';
		}

		if ($scope.formValues[fieldName] && $scope.formValues[fieldName].length > 0) {
			return 'is-valid';
		}
		return null;
	};

	$scope.getFieldMessage = function(fieldName) {
		if ($scope.validation.errors[fieldName]) {
			return $scope.validation.errors[fieldName];
		}
		return null;
	};

	$scope.getFieldDisabled = function(fieldName) {
		return $scope.status.step !== 'new';
	};

	$scope.loadSubscription = function() {
		$scope.status.loading = true;
		$http.get(ulekareBackendVars.apiUrl + 'subscriptions/' + SubscriptionFormStorage.getId())
			.then(function(res){
				$scope.status.loading = false;
				updateSubscriptionData(res);
				updateStyles();
			}, function(res){
				console.log('ERROR', res);
				$scope.status.loading = false;
			});
	};

	$scope.checkPaymentStatus = function() {
		$scope.status.loading = true;
		$http.get(ulekareBackendVars.apiUrl + 'payment/status/byId/' + SubscriptionFormStorage.getPaymentId())
			.then(function(res){
				if ($scope.status.step !== 'checkPaymentStatus') {
					return false;
				}
				$scope.status.loading = false;
				PaymentHandler.handlePayment($scope, SubscriptionFormStorage, res.data);
				if ($scope.status.step === 'done') {
					AnalyticsLogger.logStep(C.steps.thankYou);
				}
				updateStyles();
			}, function(res){
				$scope.status.loading = false;
			});
	};

	$scope.saveSubscription = function() {
		$scope.status.loading = true;

		var postData = {
			source: ulekareBackendVars.defaultFormValues.source,
		};

		for (var i in $scope.formFieldsDefinition) {
			var field = $scope.formFieldsDefinition[i];

			if (typeof field === 'object') {
				postData[field.name] = SubscriptionFormStorage.get(field.name);
			}
		}

		var apiEndpoint = ulekareBackendVars.apiUrl + 'subscriptions';

		$http.post(apiEndpoint, postData)
			.then(function(res){
				$scope.status.loading = true;
				$scope.status.step = 'checkPaymentStatus';

				updateSubscriptionData(res);
				_gopay.checkout({'gatewayUrl': SubscriptionFormStorage.get('token'), 'inline': true}, function(checkoutResult) {
					$scope.status.loading = false;
					$scope.checkPaymentStatus();
				});
			}, function(res){
				$scope.status.loading = false;
				if (res.status === 400) {
					$scope.validation.errors = res.data.error;
				}
			});
	};

	$scope.formSubmit = function() {
		if ($scope.status.step === 'new') {
			$scope.saveSubscription();
			return true;
		}
	};

	$scope.undo = function() {
		if ($scope.status.step === 'checkPaymentStatus' || $scope.status.step === 'paymentError') {
			$scope.saveSubscription();

			return true;
		}
	};

	$scope.getMissingText = function() {
		var missing = $scope.validation.missing;
		if (missing.length === 1) {
			return missing[0] + ".";
		} else {
			return missing.slice(0, -1).join(', ') + ' ' + T.translate('missing.and') + ' ' +  missing.slice(-1) + ".";
		}
	};

	$scope.fieldChange = function(fieldName) {
		if ($scope.status.lastChangedField !== fieldName) {
			AnalyticsLogger.logFormInteraction(fieldName);
		}
		$scope.status.lastChangedField = fieldName;
	};

	function updateSubscriptionData(res) {
		$scope.displayValues = res.data;
		SubscriptionFormStorage.set(res.data);
	}

	function watchFormValues(time) {
		var delay = time || 500;
		$timeout.cancel($scope.changeInterval);
		$scope.changeInterval = $timeout(function(){
			if (SubscriptionFormStorage.get('statusId') && hasSubscriptionStatusDone(SubscriptionFormStorage.get())) {
				return false;
			}
			var data = $.extend({
				'lastUpdate': Date.now()
			}, $scope.formValues);
			SubscriptionFormStorage.set(data);
			checkErrors();
		}, delay);
	}

	// init
	$scope.formFieldsDefinition = C.subscriptionFormFields;
	resetData();
	$scope.status.step = 'new';

	// we have subscription, but it was sucessfully sent
	if (SubscriptionFormStorage.hasId() && hasSubscriptionStatusDone(SubscriptionFormStorage.get())) {
		SubscriptionFormStorage.clearAll();
		resetData();
	}

	if (SubscriptionFormStorage.hasId()) {
		$scope.loadSubscription();
	}

	if (SubscriptionFormStorage.getPaymentId()) {
		$scope.checkPaymentStatus();
		$scope.status.step = 'checkPaymentStatus';
	}

	if (SubscriptionFormStorage.isLastUpdateOlderThan(1800) && SubscriptionFormStorage.get('subscription') !== null) {
		$scope.status.timeoutPopup = true;
	}

	AnalyticsLogger.logPageEnter();

	if ($scope.status.step === 'new') {
		AnalyticsLogger.logStep(C.steps.formEnter);
	}

	updateStyles();

	// watch
	$interval(function() {
		if ($scope.status.step === 'checkPaymentStatus' && $scope.status.loading === false) {
			$scope.checkPaymentStatus();
		}
	}, 2500);

	$scope.$watch("formValues", function(newValue, oldValue) {
		if (angular.equals(newValue, oldValue)) {
			return;
		}
		if (newValue.personalDataAgreement !== oldValue.personalDataAgreement) {
			watchFormValues(1);
		} else {
			watchFormValues();
		}
	}, true);
});
